import { keyframes, css } from "styled-components"

export const popUpSlideUpAnim = keyframes`
  0% {
    animation-timing-function: cubic-bezier(0.29, 0.14, 0.62, 1);
    transform: translateX(-50%) translateY(0px);
    opacity: 1;
  }
  50% {
    animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.93);
    transform: translateX(-50%) translateY(-20px);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(120px);
    opacity: 0;
  }
}
`
export const popUpSlideDownAnim = keyframes`
  0% {
    animation-timing-function: cubic-bezier(0.42, 0, 0.07, 0.93);
    transform: translateX(-50%) translateY(120px);
    opacity: 0;
  }
  50% {
    animation-timing-function: cubic-bezier(0.29, 0.14, 0.62, 1);
    transform: translateX(-50%) translateY(-20px);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}
`

export const TransitionsAnim = () => {
  const popUpSlideUp = css`
    animation: ${popUpSlideUpAnim} 0.3s 1 forwards;
  `
  const popUpSlideDown = css`
    animation: ${popUpSlideDownAnim} 0.3s 1 forwards;
  `

  return {
    popUpSlideUp,
    popUpSlideDown,
  }
}
